var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download__nav"},[_c('DownloadNavButton',{attrs:{"to":_vm.installPath,"text":"Installation"}}),_c('DownloadNavButton',{attrs:{"to":_vm.ConfigurationPath,"text":"Configuration"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }